/* ==========================================================================
   Al Basit Fragrance — product page behaviour
   Vanilla JS, no framework dependency. Talks to Shopify's Ajax Cart API
   (/cart/add.js) directly, so it works regardless of theme/cart-drawer setup.
   ========================================================================== */

(function () {
  'use strict';

  document.querySelectorAll('[data-ab-product]').forEach(initProduct);

  function initProduct(root) {
    var dataEl = root.querySelector('[data-ab-product-json]');
    if (!dataEl) return;

    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Al Basit: could not parse product JSON', e);
      return;
    }

    var state = {
      selectedOptions: (product.variants[0] || {}).options || [],
      quantity: 1
    };

    var priceEl = root.querySelector('[data-ab-price]');
    var comparePriceEl = root.querySelector('[data-ab-compare-price]');
    var qtyDisplay = root.querySelector('[data-ab-qty-display]');
    var addBtn = root.querySelector('[data-ab-add-to-cart]');
    var stickyBtn = root.querySelector('[data-ab-sticky-add]');
    var stickyPrice = root.querySelector('[data-ab-sticky-price]');
    var errorEl = root.querySelector('[data-ab-error]');
    var successEl = root.querySelector('[data-ab-success]');
    var stockNote = root.querySelector('[data-ab-stock-note]');

    function findVariant(options) {
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) {
          return opt === options[i];
        });
      })[0];
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(0);
      // Shopify stores handle currency formatting server-side normally;
      // this mirrors the store's active currency format passed from Liquid.
      return (window.AB_MONEY_FORMAT || 'Rs. {{amount}}').replace('{{amount}}', amount);
    }

    function updateUI() {
      var variant = findVariant(state.selectedOptions);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        if (stickyBtn) stickyBtn.disabled = true;
        showError('This combination is not available.');
        return;
      }
      hideError();

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      var available = variant.available;
      [addBtn, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = available
          ? (btn.getAttribute('data-ab-label') || 'Add to cart')
          : 'Sold out';
      });

      if (stockNote) {
        if (available && typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          stockNote.textContent = variant.inventory_quantity + ' left at this price';
          stockNote.style.display = '';
        } else {
          stockNote.style.display = 'none';
        }
      }

      root.querySelectorAll('[data-ab-variant-id], [data-ab-buynow-variant-id]').forEach(function (input) {
        input.value = variant.id;
      });
    }

    // Option buttons (size, scent strength, etc.)
    root.querySelectorAll('[data-ab-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-ab-option-index'), 10);
        var value = btn.getAttribute('data-ab-option-value');
        var group = btn.closest('[data-ab-option-group]');

        group.querySelectorAll('[data-ab-option-index]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        state.selectedOptions[index] = value;
        updateUI();
      });
    });

    // Quantity stepper
    root.querySelectorAll('[data-ab-qty-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.quantity = Math.max(1, state.quantity - 1);
        if (qtyDisplay) qtyDisplay.textContent = state.quantity;
      });
    });
    root.querySelectorAll('[data-ab-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.quantity = Math.min(10, state.quantity + 1);
        if (qtyDisplay) qtyDisplay.textContent = state.quantity;
      });
    });

    // Gallery thumbnails
    var mainImage = root.querySelector('[data-ab-gallery-main]');
    root.querySelectorAll('[data-ab-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-ab-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        var fullSrc = thumb.getAttribute('data-ab-full-src');
        if (mainImage && fullSrc) {
          if (mainImage.tagName === 'IMG') {
            mainImage.src = fullSrc;
          } else {
            var img = mainImage.querySelector('img');
            if (img) img.src = fullSrc;
          }
        }
      });
    });

    // Tabs
    root.querySelectorAll('[data-ab-tab-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-ab-tab-btn');
        root.querySelectorAll('[data-ab-tab-btn]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        root.querySelectorAll('[data-ab-tab-panel]').forEach(function (p) {
          p.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = root.querySelector('[data-ab-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });

    // Add to cart (AJAX)
    function addToCart() {
      var variant = findVariant(state.selectedOptions);
      if (!variant || !variant.available) return;

      [addBtn, stickyBtn].forEach(function (btn) {
        if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding…'; }
      });
      hideError();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: state.quantity })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          showSuccess('Added to your cart.');
          document.dispatchEvent(new CustomEvent('ab:cart:updated'));
          // Fall back to the cart page if no cart-drawer listener handles this event.
          if (!document.querySelector('[data-ab-cart-drawer]')) {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          showError((err && err.description) || 'Could not add this item to your cart.');
        })
        .then(function () {
          [addBtn, stickyBtn].forEach(function (btn) {
            if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-ab-label') || 'Add to cart'; }
          });
          updateUI();
        });
    }

    if (addBtn) addBtn.addEventListener('click', addToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }
    function hideError() {
      if (!errorEl) return;
      errorEl.classList.remove('is-visible');
    }
    function showSuccess(msg) {
      if (!successEl) return;
      successEl.textContent = msg;
      successEl.classList.add('is-visible');
      setTimeout(function () { successEl.classList.remove('is-visible'); }, 4000);
    }

    updateUI();
  }
})();